export enum QuestionType {
  INPUT_TEXT = 'INPUT_TEXT',
  INPUT_NUMBER = 'INPUT_NUMBER',
  INPUT_PHONE = 'INPUT_PHONE',
  RADIO_GROUP = 'RADIO_GROUP',
  CHECK_GROUP = 'CHECK_GROUP',
  SELECT = 'SELECT',
  DATE = 'DATE',
  DATE_RANGE = 'DATE_RANGE'
}
